import BaseApi from 'api/BaseApi';
import { IAddressValue } from 'api/types';

interface IGetSuggestionsParams {
  inputValue: string;
  countries?: string[];
  sessionToken?: string;
}

interface IGetAddressParams {
  placeId: string;
  sessionToken?: string;
}

export interface ISuggestion {
  description: string;
  placeId: string;
}

export interface IAddressLookupApi {
  getSuggestions(params: IGetSuggestionsParams): Promise<ISuggestion[]>;
  getAddress(params: IGetAddressParams): Promise<IAddressValue>;
}

export default class AddressLookupRestApi extends BaseApi implements IAddressLookupApi {
  protected resourceName = 'address-lookup';

  public getSuggestions(params: IGetSuggestionsParams): Promise<ISuggestion[]> {
    const urlSearchParams = new URLSearchParams();

    urlSearchParams.append('inputValue', params.inputValue);

    if (params.countries) {
      params.countries.forEach((country) => urlSearchParams.append('countries', country));
    }

    if (params.sessionToken) {
      urlSearchParams.append('sessionToken', params.sessionToken);
    }

    return this.fetch(`/${this.resourceName}/suggestions?${urlSearchParams}`);
  }

  public getAddress(params: IGetAddressParams): Promise<IAddressValue> {
    const urlSearchParams = new URLSearchParams();

    if (params.sessionToken) {
      urlSearchParams.append('sessionToken', params.sessionToken);
    }

    return this.fetch(`/${this.resourceName}/places/${params.placeId}?${urlSearchParams}`);
  }
}
